<section class="bg-home">
  <div class="bg-overlay"></div>
  <div class="home-center">
    <div class="home-desc-center">
      <div class="container">
        <app-shared-search
          [inputSearch]="stateZip"
          (search)="onSearch($event)"
          #searchComponent
        ></app-shared-search>
      </div>
    </div>
  </div>
</section>
<section class="section division-section" *ngIf="division === 'DEDICT'">
  <div class="container">
    <div class="row">
      <div class="dedicated col">
        <h2>Dedicated Jobs</h2>
        <div class="division-description">
          Regular Routes • Consistent Miles Great Pay • Relationships with Customers
        </div>
        <div class="division-description">
          Each day brings new opportunity, in dedicated there is one thing you can count on –
          consistent miles with regular routes and best of all, great pay. Though home time, miles,
          and pay are dependent on markets and regions, we offer the predictable lifestyle you’re
          looking for in a career with team, solo, and training positions available.
        </div>
        <a
          href="https://careers.crengland.com/truck-driving-jobs/dedicated"
          class="btn-learn btn btn-custom"
          >Learn More</a
        >
      </div>
    </div>
  </div>
</section>
<section class="section division-section" *ngIf="division === 'OVER_THE_ROAD'">
  <div class="container">
    <div class="row">
      <div class="dedicated col">
        <h2>Over the Road Jobs</h2>
        <div class="division-description">Great Miles • Competitive • Pay Explore the Country</div>
        <div class="division-description">
          If your passion is to drive and have the freedom to see the country, this is the division
          for you. With great miles, competitive pay and the freedom you’re looking for, this
          division has never been better. You can enjoy life on the road while earning one day off
          for every week out. If you’re up for an adventure, the Over the Road division is for you.
        </div>
        <a
          href="https://careers.crengland.com/truck-driving-jobs/national"
          class="btn-learn btn btn-custom"
          >Learn More</a
        >
      </div>
    </div>
  </div>
</section>
<section class="section division-section" *ngIf="division === 'INTMDL'">
  <div class="container">
    <div class="row">
      <div class="dedicated col">
        <h2>Intermodal Jobs</h2>
        <div class="division-description">
          Local Routes • Home Almost Every Day Flexible Schedules • Competitive Pay
        </div>
        <div class="division-description">
          Intermodal serves all the major freight markets in the U.S., with local driving positions
          running up to 200 miles from the rail to the customer and back. There’s a lot to like
          about Intermodal – you’re home almost every day, you have a flexible schedule and
          competitive pay. The drivers in this division are in high demand and are carefully
          selected because of their driving skills and ability to communicate well with our
          customers.
        </div>
        <a
          href="https://careers.crengland.com/truck-driving-jobs/intermodal"
          class="btn-learn btn btn-custom"
          >Learn More</a
        >
      </div>
    </div>
  </div>
</section>
<section class="section division-section" *ngIf="experience">
  <div class="container">
    <div class="row">
      <div class="dedicated col">
        <h2>Need CDL Jobs</h2>
        <div class="division-description">We train • We hire • We Pay</div>
        <div class="division-description">
          C.R. England’s partner, Premier Truck Driving Schools, trains truck drivers across the
          nation. We offer travel and sleeping accommodations to students traveling to the various
          CDL school locations. Fill out our
          <a href="https://careers.crengland.com/">truck driving job</a> application to learn more
          about getting started at a trucking school location near you.
        </div>
        <a href="https://schools.crengland.com/" class="btn-learn btn btn-custom">Learn More</a>
      </div>
    </div>
  </div>
</section>
<section class="section filters">
  <div class="container">
    <div class="row">
      <div class="col-lg-10">
        <div class="row">
          <div
            [class.col-lg-3]="!isUniquePage"
            [class.col-lg-4]="isUniquePage"
            *ngIf="!isUniquePage || (isUniquePage && experience)"
          >
            <div class="search-type">
              <span>Division</span>
            </div>
            <span class="p-fluid">
              <p-multiSelect
                defaultLabel="Select Division(s)"
                [maxSelectedLabels]="0"
                [(ngModel)]="selectedDivisions"
                (onChange)="filtersChanged($event)"
                [options]="divisions"
                [selectedItemsLabel]="'({1}) Selected'"
                [showHeader]="false"
                [styleClass]="selectedDivisions.length === 0 ? 'no-selected' : ''"
              ></p-multiSelect>
            </span>
          </div>
          <div [class.col-lg-3]="!isUniquePage" [class.col-lg-4]="isUniquePage">
            <div class="search-type">
              <span>Driver Type</span>
            </div>
            <span class="p-fluid">
              <p-multiSelect
                defaultLabel="Select Driver Type(s)"
                [maxSelectedLabels]="0"
                [(ngModel)]="selectedDriverTypes"
                (onChange)="filtersChanged($event)"
                [options]="driverTypes"
                [selectedItemsLabel]="'({1}) Selected'"
                [showHeader]="false"
                [styleClass]="selectedDriverTypes.length === 0 ? 'no-selected' : ''"
              ></p-multiSelect>
            </span>
          </div>
          <div
            [class.col-lg-3]="!isUniquePage"
            [class.col-lg-4]="isUniquePage"
            *ngIf="!isUniquePage || (isUniquePage && division)"
          >
            <div class="search-type">
              <span>Experience</span>
            </div>
            <span class="p-fluid">
              <p-multiSelect
                defaultLabel="Select Experience(s)"
                [maxSelectedLabels]="0"
                [(ngModel)]="selectedExperiences"
                (onChange)="filtersChanged($event)"
                [options]="experiences"
                [selectedItemsLabel]="'({1}) Selected'"
                [showHeader]="false"
                [styleClass]="selectedExperiences.length === 0 ? 'no-selected' : ''"
              ></p-multiSelect>
            </span>
          </div>
          <div [class.col-lg-3]="!isUniquePage" [class.col-lg-4]="isUniquePage">
            <div class="search-type">
              <span>Home Time</span>
            </div>

            <span class="p-fluid">
              <p-multiSelect
                defaultLabel="Select Home Time(s)"
                [maxSelectedLabels]="0"
                [(ngModel)]="selectedHomeTimes"
                (onChange)="filtersChanged($event)"
                [options]="homeTimes"
                [selectedItemsLabel]="'({1}) Selected'"
                [showHeader]="false"
                [styleClass]="selectedHomeTimes.length === 0 ? 'no-selected' : ''"
              ></p-multiSelect>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-2">
        <button
          [ngClass]="{
            'btn-clear-no-selection':
              selectedDivisions.length === 0 &&
              selectedDriverTypes.length === 0 &&
              selectedExperiences.length === 0 &&
              selectedHomeTimes.length === 0
          }"
          class="btn btn-clear btn-block"
          (click)="onClear()"
        >
          Clear
        </button>
      </div>
    </div>
  </div>
</section>
<section class="section mobile-filters">
  <p-panel
    [collapsed]="true"
    [collapseIcon]="'pi pi-chevron-up'"
    [expandIcon]="'pi pi-chevron-down'"
    [toggleable]="true"
  >
    <p-header class="p-header">
      <i class="fas fa-sliders-h"></i>
      <span>
        Filters<span
          *ngIf="
            selectedDivisions.length !== 0 ||
            selectedDriverTypes.length !== 0 ||
            selectedExperiences.length !== 0 ||
            selectedHomeTimes.length !== 0
          "
          >: ({{
            selectedHomeTimes.length +
              selectedDivisions.length +
              selectedDriverTypes.length +
              selectedExperiences.length
          }}) Selected</span
        ></span
      >
    </p-header>
    <div class="container">
      <div class="row">
        <div class="col-lg-10">
          <div class="row">
            <div class="col-lg-3 mb-3" *ngIf="!isUniquePage">
              <div class="search-type">
                <span>Division(s)</span>
              </div>
              <p-selectButton
                multiple="multiple"
                [(ngModel)]="selectedDivisions"
                (onChange)="filtersChanged($event)"
                [options]="divisions"
              ></p-selectButton>
            </div>
            <div class="mb-3" [class.col-lg-3]="!isUniquePage" [class.col-lg-4]="isUniquePage">
              <div class="search-type">
                <span>Driver Type(s)</span>
              </div>
              <p-selectButton
                multiple="multiple"
                [(ngModel)]="selectedDriverTypes"
                (onChange)="filtersChanged($event)"
                [options]="driverTypes"
              ></p-selectButton>
            </div>
            <div class="mb-3" [class.col-lg-3]="!isUniquePage" [class.col-lg-4]="isUniquePage">
              <div class="search-type">
                <span>Experience(s)</span>
              </div>
              <p-selectButton
                multiple="multiple"
                [(ngModel)]="selectedExperiences"
                (onChange)="filtersChanged($event)"
                [options]="experiences"
              ></p-selectButton>
            </div>
            <div class="mb-3" [class.col-lg-3]="!isUniquePage" [class.col-lg-4]="isUniquePage">
              <div class="search-type">
                <span>Home Time(s)</span>
              </div>

              <p-selectButton
                multiple="multiple"
                [(ngModel)]="selectedHomeTimes"
                (onChange)="filtersChanged($event)"
                [options]="homeTimes"
              ></p-selectButton>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <button
            [ngClass]="{
              'btn-clear-no-selection':
                selectedDivisions.length === 0 &&
                selectedDriverTypes.length === 0 &&
                selectedExperiences.length === 0 &&
                selectedHomeTimes.length === 0
            }"
            class="btn btn-clear btn-block"
            (click)="onClear()"
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>
  </p-panel>
</section>
<section *ngIf="jobs.length === 0 && !isLoading" class="section no-jobs">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-2">
        <div class="text-center mb-3">
          <div class="slash"></div>
        </div>
      </div>
      <div class="col-lg-10 sorry">
        <div class="mb-3">
          <h4>Sorry, we don't have any jobs like that right now.</h4>
          <h5>Try adjusting your search by changing your state, zip code, or removing filters.</h5>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="section job-list-loading" *ngIf="isLoading">
  <div class="container">
    <div class="row">
      <!-- Job Counter-->
      <div class="col-lg-4 mb-2">
        <ngx-skeleton-loader
          count="1"
          [theme]="{ 'border-radius': '4px', height: '50px' }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="tab-content">
          <div>
            <div class="row mb-5">
              <div class="col-lg-12">
                <!-- JOB BOX STARTS-->
                <app-shared-job-loading></app-shared-job-loading>
                <app-shared-job-loading></app-shared-job-loading>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="section job-list" *ngIf="jobs.length !== 0 && !isLoading">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="title mb-4">
          <h1>{{ this.title }}</h1>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="tab-content" id="pills-tabContent">
          <div>
            <div class="row mb-5">
              <div class="col-lg-12">
                <!-- JOB BOX STARTS-->
                <a
                  class="pointer"
                  (click)="goToOverview(job.jobId, job.city, job.state)"
                  *ngFor="let job of jobs"
                >
                  <div class="job-box bg-white mt-4">
                    <div class="p-4">
                      <div class="row gray">
                        <div class="col-xl-9">
                          <div>
                            <h6>
                              <a
                                (click)="goToOverview(job.jobId, job.city, job.state)"
                                class="gray"
                                >{{ job.title }}</a
                              >
                              <app-shared-display-badge [division]="job.division">
                              </app-shared-display-badge>
                            </h6>
                            <p class="mb-0">
                              <app-shared-display-city-state
                                [city]="job.city"
                                [state]="job.state"
                              ></app-shared-display-city-state>
                            </p>
                            <div class="mb-0" [innerHTML]="job.description | shortNote"></div>
                          </div>
                        </div>
                        <div class="col-xl-3 details gray">
                          <app-shared-job-properties [job]="job"></app-shared-job-properties>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-shared-featured-jobs></app-shared-featured-jobs>
